/** Field visibility presets for Pricing / Inventory / Shipping by product details mode. */

export const PRICING_PRESETS = {
  simple: {},
  variant: {},
};

export const INVENTORY_PRESETS = {
  skuCodes: {
    hideTracked: true,
    hideCompliance: true,
    hideTaxCode: true,
    hideInventoryPolicy: true,
  },
};

export const SHIPPING_PRESETS = {
  simple: {
    showComplianceFields: true,
  },
  variant: {
    showComplianceFields: true,
  },
};
